import NoMatch from "@containers/no-match";

import { ROUTES } from "@constants/routes";
import { RouteType } from "./types";
import TaskManagementSettings from "@containers/TaskManagement/Settings";
import AllTasksList from "@containers/TaskManagement/AllTasksList";
import TaskDetails from "@containers/TaskManagement/TaskDetails";
import OwnTasksList from "@containers/TaskManagement/OwnTasksList";
import SharedTasksList from "@containers/TaskManagement/SharedTasksList";
import AssignedTasksList from "@containers/TaskManagement/AssignedTasksList";
import AssignedSubTasksList from "@containers/TaskManagement/AssignedSubTasksList";
import SharedSubTasksList from "@containers/TaskManagement/SharedSubTasksList";
import SubTaskDetails from "@containers/TaskManagement/SubTaskDetails";
import ArchivedTasksList from "@containers/TaskManagement/ArchivedTasksList";

const { TASK_MANAGEMENT, CREATE, ID, ID_2 } = ROUTES;

const {
  SETTINGS,
  ALL_TASKS,
  OWN_TASKS,
  SHARED_TASKS,
  ASSIGNED_TASKS,
  SUB_TASKS,
  ASSIGNED_SUB_TASKS,
  SHARED_SUB_TASKS,
  ARCHIVED_TASKS,
} = TASK_MANAGEMENT;

export const TaskManagementRoutes: RouteType[] = [
  // ALL TASKS
  {
    id: "all_tasks_module",
    path: ALL_TASKS,
    children: [
      {
        id: "all_tasks_list",
        index: true,
        element: <AllTasksList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TASK_HEAD",
        },
      },
      {
        id: "all_tasks_create",
        path: CREATE,
        element: <TaskDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TASK_HEAD",
        },
      },
      {
        id: "all_tasks_details",
        path: ID,
        element: <TaskDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TASK_HEAD",
        },
      },
      {
        id: "sub_task_create",
        path: `${ID}/${CREATE}`,
        element: <SubTaskDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TASK_HEAD",
        },
      },
      {
        id: "sub_task_details",
        path: `${ID}/${ID_2}`,
        element: <SubTaskDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TASK_HEAD",
        },
      },
    ],
  },

  // OWN TASKS
  {
    id: "own_tasks_module",
    path: OWN_TASKS,
    children: [
      {
        id: "own_tasks_list",
        index: true,
        element: <OwnTasksList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TASK_VIEW_OWN_TASK",
        },
      },
    ],
  },

  // SHARED TASKS
  {
    id: "shared_tasks_module",
    path: SHARED_TASKS,
    children: [
      {
        id: "shared_tasks_list",
        index: true,
        element: <SharedTasksList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TASK_VIEW_OWN_TASK",
        },
      },
    ],
  },

  // ASSIGNED TASKS
  {
    id: "assigned_tasks_module",
    path: ASSIGNED_TASKS,
    children: [
      {
        id: "assigned_tasks_list",
        index: true,
        element: <AssignedTasksList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TASK_VIEW_OWN_TASK",
        },
      },
    ],
  },

  // SHARED SUB TASKS
  {
    id: "shared_sub_task_module",
    path: SHARED_SUB_TASKS,
    children: [
      {
        id: "shared_sub_task_list",
        index: true,
        element: <SharedSubTasksList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TASK_VIEW_OWN_TASK",
        },
      },
    ],
  },

  // ASSIGNED SUB TASKS
  {
    id: "assigned_sub_task_module",
    path: ASSIGNED_SUB_TASKS,
    children: [
      {
        id: "assigned_sub_task_list",
        index: true,
        element: <AssignedSubTasksList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TASK_VIEW_OWN_TASK",
        },
      },
    ],
  },

  // ARCHIVED TASKS
  {
    id: "archived_tasks_module",
    path: ARCHIVED_TASKS,
    children: [
      {
        id: "archived_tasks_list",
        index: true,
        element: <ArchivedTasksList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TASK_HEAD",
        },
      },
      {
        id: "archived_tasks_details",
        path: ID,
        element: <TaskDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TASK_HEAD",
        },
      },
      {
        id: "sub_task_create",
        path: `${ID}/${CREATE}`,
        element: <SubTaskDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
      {
        id: "sub_task_details",
        path: `${ID}/${ID_2}`,
        element: <SubTaskDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
    ],
  },

  // SETTINGS
  {
    id: "settings_module",
    path: SETTINGS,
    children: [
      {
        id: "settings",
        index: true,
        element: <TaskManagementSettings />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "TASK_HEAD",
        },
      },
    ],
  },
];
